import { render, staticRenderFns } from "./Maslist.vue?vue&type=template&id=aa1225c8&scoped=true&"
import script from "./Maslist.vue?vue&type=script&lang=js&"
export * from "./Maslist.vue?vue&type=script&lang=js&"
import style0 from "./Maslist.vue?vue&type=style&index=0&id=aa1225c8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa1225c8",
  null
  
)

export default component.exports